import axios from 'axios';
import config from '../config';

const domain = config.api_domain.domain

const LoaderScraping = async (fuel_price, energy_price) => {
    try {
        const customer = localStorage.getItem('country_name')
        const url = (`${domain}/scraping_data/${fuel_price}/${energy_price}/${customer}`)
        const res = await axios.get(url)
        return (res.data.body)
        
    } catch (error) {
        console.error(error);
        return null;
    }
}

export default LoaderScraping